import ApiService from '@/services/ApiService';
import UtilsService from '@/services/UtilsService';
import FeatureFlagQueries from '@/queries/featureFlag.queries';
import { FeatureFlagStatus } from '@/models';
import store from '@/store';
import { FeatureFlag } from '../models';

function isNew(featureFlag: FeatureFlag): boolean {
  if (!featureFlag.releaseDate) {
    return false;
  }

  const today = new Date();
  const releaseDate = new Date(featureFlag.releaseDate.iso);
  const daysCount = (today.getTime() - releaseDate.getTime()) / (1000 * 3600 * 24);

  return featureFlag.status === FeatureFlagStatus.Ready && daysCount < 7;
}

function getAllFeatureFlags(currentUser: any) {
  const query = FeatureFlagQueries.getAll(currentUser && currentUser.retailer.objectId);

  return ApiService.get(UtilsService.buildFullPath(query));
}

export function getFeatureFlag(feature: any) {
  const featureFlag = store.state.featureFlag &&
      store.state.featureFlag.featureFlags.find((flag: any) => flag.feature === feature);

  if (featureFlag) {
    return {
      alpha: featureFlag.status === FeatureFlagStatus.Alpha,
      beta: featureFlag.status === FeatureFlagStatus.Beta,
      new: isNew(featureFlag),
    };
  }
  return false;
}

const FeatureFlagService = {
  getAllFeatureFlags,
  getFeatureFlag,
};

export default FeatureFlagService;
